import * as React from 'react';
import { Skeleton } from '@mui/material';
import { GridColDef, GridColumns, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { SmartScreenshotResponse } from 'services/clients/perDiem';
import { SmartRow } from '../types';
import { Date, Fightable, Restrictions, Screenshots, Shift, Time, UpgradePlanCell } from './cells';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RenderCell = (params: GridRenderCellParams<any, SmartRow, any>) => React.ReactNode;

// Render a mui skeleton placeholder when the row is a placeholder
const withSkeleton = (renderCell?: RenderCell): RenderCell => {
  return (params) => {
    if (params.row.type === 'placeholder') {
      return <Skeleton width="100%" />;
    }

    if (renderCell) {
      return renderCell(params);
    }

    return null;
  };
};

const defaultColumn: Partial<GridColDef<SmartRow>> = {
  sortable: false,
  cellClassName: 'p-4',
  headerClassName: 'p-4',
  resizable: false,
};

export const getColumns: (
  onModal: (code: SmartScreenshotResponse['code']) => void,
  canAccessPerDiem: boolean,
  variant?: 'minimal'
) => GridColumns<SmartRow> = (onModal, canAccessPerDiem, variant) => {
  return [
    {
      ...defaultColumn,
      field: 'date',
      headerName: 'Date',
      renderCell: withSkeleton((params) => <Date row={params.row} />),
      width: 130,
    },
    {
      ...defaultColumn,
      field: 'shift',
      headerName: 'Shift',
      renderCell: withSkeleton((params) => <Shift row={params.row} />),
      width: 85,
    },
    {
      ...defaultColumn,
      field: 'time',
      headerName: 'Time',
      renderCell: withSkeleton((params) => <Time row={params.row} />),
      minWidth: 100,
    },
    {
      ...defaultColumn,
      field: 'restrictions',
      headerName: 'Terminal restrictions',
      renderCell: withSkeleton((params) => <Restrictions row={params.row} />),
      flex: 1,
    },
    {
      ...defaultColumn,
      field: 'fightable',
      headerName: 'Can dispute',
      renderCell: withSkeleton((params) => <Fightable row={params.row} variant={variant} />),
      width: variant === 'minimal' ? 64 : 140,
    },
    {
      ...defaultColumn,
      field: 'screenshots',
      headerName: 'Screenshots',
      renderCell: withSkeleton((params) =>
        canAccessPerDiem ? (
          <Screenshots row={params.row} onModal={onModal} variant={variant} />
        ) : (
          <UpgradePlanCell row={params.row} />
        )
      ),
      width: variant === 'minimal' && canAccessPerDiem ? 64 : 190,
    },
  ];
};
